$(document).on('change','.js-qty__num_cart',function(){
    var qty = $(this).val();
    var productid = $(this).parent().parent().prev().attr('dataselectproductid');
    var selectclass = $(this).parent().parent().prev();
    plusminusnum(qty,productid,selectclass);
    
});
$(document).on('click','.js-qty__adjust--minus_cart',function(){
    var qty = $(this).prev().val();
    var productid = $(this).parent().parent().prev().attr('dataselectproductid');
    var selectclass = $(this).parent().parent().prev();
    plusminusnum(qty,productid,selectclass);
    
});
$(document).on('click','.js-qty__adjust--plus_cart',function(){
    var qty = $(this).prev().prev().val();
    var productid = $(this).parent().parent().prev().attr('dataselectproductid');
    var selectclass = $(this).parent().parent().prev();
    plusminusnum(qty,productid,selectclass);
});
function plusminusnum(qty,productid,selectclass){
    console.log(qty,productid,selectclass);
    $('.product-single__variants option[dataoptionproductid=' + productid + ']').each(function(){
        var selectval = $(this).attr('datavarianttitle').split('-');
        var selectone = parseInt(selectval[0]);
        var selecttwo = parseInt(selectval[1]);
        console.log(qty >= selectone &&  qty <= selecttwo);
        if(qty >= selectone && qty <= selecttwo){
            $(this).trigger('change');
            $('.product-single__variants option[dataoptionproductid=' + productid + ']:selected').each(function(){
                $(this).removeAttr("selected");
            });
            $(this).attr("selected", "selected");
            $(this).val();
            console.log("ifqtyselected");
        }
        else if(qty >= selectone){
            $(this).trigger('change');
            $('.product-single__variants option[dataoptionproductid=' + productid + ']:selected').each(function(){
                $(this).removeAttr("selected");
            });
            $(this).attr("selected", "selected");
            $(this).val();
            console.log("elseqtyselected");
        }
    });
    var element = $('.cart_item_productid_'+productid).find('.product-single__variants').find('option:selected'); 
    var variantprice = element.attr("data-variantprice");
    var variantvalue = element.attr("value");
    var currentvarible = $('.cart_item_productid_'+productid).attr('data-id');
    var currentkey = $('.cart_item_productid_'+productid).attr('data-key');
    console.log('new:',variantvalue,' current:',currentvarible);
    if(variantvalue != currentvarible ){
      $('.js-qty__wrapper_cart').addClass('is-loading');
      var newqty = 0;
      var data = { updates: {} };
      data.updates[currentvarible] = newqty;
      setTimeout(function(){
        $.ajax({
            method:'post',
            url:'/cart/update.js',
            data: data,
            dataType: 'json',
            beforeSend: function(){
              $('.js-qty__wrapper_cart').addClass('is-loading');
            },
            success: function(data){
                console.log(data,'change');
              // setTimeout(function(){
                $.ajax({
                    method:'post',
                    url:'/cart/add',
                    data: {id:variantvalue,quantity:qty},
                    dataType: 'json',
                    success:function(data){
                        setTimeout(function(){
                            window.location.href="/cart";
                            },1000);
                        console.log(data,'add');
                    }
                });
              // },1000);
            }
        });
      },1000);
    }
}